// lib/api/authFetch.js
import { useAppStore } from "lib/store/useAppStore";

/**
 * fetch + 쿠키 포함 + (401이면 refresh 후 1회 재시도)
 * - 응답 바디 형태는 건드리지 않고 Response 그대로 반환
 * - refresh 엔드포인트는 무한루프 방지로 재시도 로직 제외
 */
export async function authFetch(input, init = {}, opts = {}) {
  const {
    refreshUrlIncludes = "/api/auth/refresh", // 너네 refresh 경로 일부 문자열
    retryOnceOn401 = true,
    setUnauthOnFinal401 = true,
  } = opts;

  const doFetch = () =>
    fetch(input, {
      credentials: "include",
      ...init,
      headers: {
        ...(init.headers || {}),
      },
    });

  // 1차 요청
  let res = await doFetch();

  // 401 아니면 바로 반환
  if (res.status !== 401) return res;

  // refresh 요청 자체는 여기서 끝 (무한루프 방지)
  const urlStr = typeof input === "string" ? input : input?.url || "";
  if (urlStr.includes(refreshUrlIncludes)) return res;

  if (!retryOnceOn401) return res;

  // refresh 시도
  const st = useAppStore.getState();
  if (typeof st.refresh !== "function") return res;

  try {
    await st.refresh(); // ✅ 너 store의 refreshPromise로 동시호출 합쳐짐
  } catch {
    if (setUnauthOnFinal401) st.setUnauthenticated?.();
    return res;
  }

  // 1회 재시도
  const res2 = await doFetch();

  // 재시도도 401이면(최종 실패) 상태 반영(선택)
  if (res2.status === 401 && setUnauthOnFinal401) {
    st.setUnauthenticated?.();
  }

  return res2;
}
